import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { Popup } from 'es6/libs/popup'
import $ from 'init/jquery'
import isFunction from 'lodash/isFunction'
import { Raven } from 'init/raven'
import { getGlobalEventBus } from 'init/backbone'

/**
 * Декоратор инициализации представления попапа.
 * @param {Object} options Опции для представления попапа.
 * @param {jQuery} options.$opener Открывающий элемент.
 * @param {jQuery} [options.$closer] Закрывающий элемент.
 * @param {BodyView} [options.bodyView] Вид страницы.
 * @returns {Function}
 */
export const appendFillPopup = options => {
  return function (target) {
    Object.defineProperty(target.prototype, '_initMobileFillPopup', {
      writable: true,
      value: function () {
        try {
          if (Object.keys(options).length) {
            const result = {}
            Object.keys(options).forEach(optionKey => {
              if (isFunction(options[optionKey])) {
                result[optionKey] = options[optionKey].apply(this)
              } else {
                result[optionKey] = options[optionKey]
              }
            })
            if (result.el instanceof $) {
              this.childViews._popupView = new MobilePopupFillView({
                ...result,
                bodyView: this.bodyView,
              })
            }
          }
        } catch (e) {
          Raven.captureException(e)
        }
      },
    })
  }
}

@Defaults({
  additionalOptions: [
    '$opener',
    '$closer',
    'bodyView',
    'beforeOpen',
    'beforeClose',
  ],
  currentBackScroll: 0,
  bodyLockClass: 'no-back-scroll-modify',
  /**
   * Признак того что при открытии попапа, боди уже имеет блокирующий класс
   * Ситуации открытия попапа в попапе
   */
  bodyHasLockClass: false,
})
/**
 * Вид попапа на весь экран для мобильной версии.
 */
export class MobilePopupFillView extends View {
  /**
   * @inheritDoc
   */
  run () {
    this.$el.addClass('popup-mobile-fill-block')
    this.eventBus = getGlobalEventBus()
    this.$opener = this.$opener || null
    this.popup = new Popup(this.$el, this.$opener, this.$closer)
    this.popup.addEventListener(
      Popup.EventType.BEFORE_OPEN,
      ($event, dataTarget) => {
        this.currentBackScroll = $(document).scrollTop()
        if (isFunction(this.beforeOpen)) {
          this.beforeOpen($event, dataTarget)
        }
        this.bodyHasLockClass = $('body').hasClass(this.bodyLockClass)
        this.toggleBodyLayoutView(true)
        if (this.bodyHasLockClass) {
          this.toggleBodyScrollLock(!this.bodyHasLockClass)
        }
        $(document).scrollTop(0)
      }
    )
    this.popup.addEventListener(
      Popup.EventType.BEFORE_CLOSE,
      ($event, dataTarget) => {
        if (isFunction(this.beforeClose)) {
          this.beforeClose($event, dataTarget)
        }
        this.toggleBodyLayoutView(false)
        if (this.bodyHasLockClass) {
          this.toggleBodyScrollLock(this.bodyHasLockClass)
        }
        $(document).scrollTop(this.currentBackScroll)
      }
    )
  }

  /**
   * Поведение для iOS браузеров.
   * Показывает/скрывает родителя инициатора.
   * @see https://bugs.webkit.org/show_bug.cgi?id=153852
   * @param {boolean} isHidden Признак скрытия блоков.
   */
  toggleBodyLayoutView (isHidden) {
    if (this.bodyView) {
      this.bodyView.toggleLayoutView(!isHidden)
    } else {
      this.eventBus.trigger('toggle-layout-view', !isHidden)
    }
  }

  /**
   * Нормальное поведение для попапа.
   * Блокирует/разблокирует скролл родителя инициатора.
   * @param {boolean} isUnscrollable Признак блокировки скролла.
   */
  toggleBodyScrollLock (isUnscrollable) {
    if (this.bodyView) {
      this.bodyView.toggleScrollLock(this.bodyLockClass, isUnscrollable)
    } else {
      this.eventBus.trigger('block-screen', this.bodyLockClass, isUnscrollable)
    }
  }
}
